export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/signin',
    SIGNUP: '/api/auth/signup',
    REFRESH: '/api/auth/refresh-token',
    ME: '/api/auth/me',
  },
  BILLING: {
    MY_BILL: '/api/billing/my-bill',
    BALANCES: '/api/billing/balances',
  },
  PAYMENTS: {
    MY_PAYMENTS: '/api/payments/my',
    MY_DETAILS: '/api/payments/details',
    STUDENT_DETAILS: (id: string | number) => `/api/payments/details/student/${id}`,
    TEACHER_STUDENTS: '/api/payments/teacher/students',
    TEACHER_OUTSTANDING: '/api/payments/teacher/outstanding',
    ADMIN_ALL: '/api/payments/admin',
    VERIFY: (id: string | number) => `/api/payments/${id}/verify`,
    RECORD_PAYMENT: '/api/payments/my/record',
  },
  EXAMS: {
    STUDENT_MY: '/api/exams/student/my',
    STUDENT_NEXT: '/api/exams/student/next',
    STUDENT_DETAIL: (id: string | number) => `/api/exams/student/${id}`,
    STUDENT_AVAILABLE: '/api/exams/student/available',
    STUDENT_BOOK: (id: string | number) => `/api/exams/student/${id}/book`,
    TEACHER_ALL: '/api/exams/teacher/all',
    TEACHER_DETAIL: (id: string | number) => `/api/exams/teacher/${id}`,
    TEACHER_SLOTS: '/api/exams/teacher/slots',
    TEACHER_UPDATE: (id: string | number) => `/api/exams/teacher/${id}`,
    TEACHER_RESULT: (id: string | number) => `/api/exams/teacher/${id}/result`,
    ADMIN_ALL: '/api/exams/admin/all',
    ADMIN_CREATE: '/api/exams/admin',
    ADMIN_STUDENT: (studentId: string | number) => `/api/exams/admin/student/${studentId}`,
    ADMIN_UPDATE: (id: string | number) => `/api/exams/admin/${id}`,
    NOTES: (id: string | number) => `/api/exams/${id}/notes`,
  },
  PARAMETERS: {
    PUBLIC: '/api/parameters/public',
    PORTAL: '/api/parameters/portal',
    ADMIN_ALL: '/api/parameters/admin',
    ADMIN_DETAIL: (key: string) => `/api/parameters/admin/${key}`,
    ADMIN_UPSERT: '/api/parameters/admin',
    ADMIN_UPSERT_ONE: (key: string) => `/api/parameters/admin/${key}`,
  },
  LESSONS: {
    ALL: '/api/lessons',
    AVAILABLE: '/api/lessons/available',
    AVAILABLE_DATE_RANGE: '/api/lessons/available/date-range',
    BOOK: (id: string | number) => `/api/lessons/${id}/book`,
    CANCEL: (id: string | number) => `/api/lessons/${id}/cancel`,
    DETAIL: (id: string | number) => `/api/lessons/${id}`,
    STATISTICS_STUDENT: '/api/lessons/statistics/student',
    STATISTICS_TEACHER: '/api/lessons/statistics/teacher',
    TEACHER_LESSONS: '/api/lessons/my-teaching',
    UPDATE: (id: string | number) => `/api/lessons/${id}/update`,
    PICKUP_LOCATION: (id: string | number) => `/api/lessons/${id}/pickup-location`,
    NOTES: (id: string | number) => `/api/lessons/${id}/notes`,
    NOTES_TEACHER: (id: string | number) => `/api/lessons/${id}/notes/teacher`,
    NOTES_STUDENT: (id: string | number) => `/api/lessons/${id}/notes/student`,
    RATE: (id: string | number) => `/api/lessons/${id}/rate`,
    GRADE: (id: string | number) => `/api/lessons/${id}/grade`,
    VIDEO: (id: string | number) => `/api/lessons/${id}/video`,
    CONSENT: (id: string | number) => `/api/lessons/${id}/consent`,
    MY_LESSONS: '/api/lessons/my-lessons',
    MY_AVAILABLE: '/api/lessons/my-available',
    MY_TEACHING_PAGE: '/api/lessons/my-teaching/page',
    BULK_CREATE: '/api/lessons/bulk-create',
  },
  USERS: {
    GET: (id: string | number) => `/api/users/${id}`,
    AVATAR: '/api/users/me/avatar',
    PROFILE: '/api/users/me/profile',
  },
  ADMIN: {
    USERS: '/super-admin/api/users',
    USER_DETAIL: (id: string | number) => `/super-admin/api/users/${id}`,
    TEACHERS_AND_STUDENTS: '/super-admin/api/teachers-and-students',
    STUDENT_STATISTICS: (id: string | number) => `/super-admin/api/students/${id}/statistics`,
    LESSONS_PAGE: '/super-admin/api/lessons/page',
    CLEANUP_LESSONS: '/super-admin/api/lessons/cleanup',
    CREATE_TEACHER: '/super-admin/api/teachers',
    ASSIGN_STUDENT: '/super-admin/api/users/assign-student',
    UNLOCK_USER: (username: string) => `/super-admin/api/users/unlock?username=${username}`,
    DEACTIVATE_USER: (id: string | number) => `/super-admin/api/users/${id}/deactivate`,
    TEACHER_SCHEDULE: (id: string | number) => `/super-admin/api/teachers/${id}/working-schedule`,
  },
  TEACHER: {
    STUDENTS: '/api/teacher/students',
    STUDENT_DETAIL: (id: string | number) => `/api/teacher/students/${id}`,
    STUDENT_BILL: (id: string | number) => `/api/teacher/students/${id}/bill`,
    STUDENT_EXAMS: (id: string | number) => `/api/teacher/students/${id}/exams`,
    MY_LESSONS: '/api/teacher/lessons',
    MY_SCHEDULE: '/api/teacher/working-schedule',
    IMPORT: '/api/teacher/import',
  }
};
